import { render, staticRenderFns } from "./CommunityColumn.vue?vue&type=template&id=3de92b10&"
import script from "./CommunityColumn.vue?vue&type=script&lang=js&"
export * from "./CommunityColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports